import router from "./router";
import menu from "./menu";

export default {
    menu,
    router
};